import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import InputAdornment from '@mui/material/InputAdornment';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { getwarehouse } from '../redux/warehouse';
import Progress from '../components/Loader';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 550,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function BasicModal() {
  const [open, setOpen] = React.useState(false);
  const [loading, setloading] = React.useState(false);
  const [warehousetype, setwarehousetype] = React.useState("none");
  const [personName, setPersonName] = React.useState([]);
  const [multicrops, setmulticrops] = React.useState([]);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');
  const dispatch = useDispatch();

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const names = [
    "Forklifts",
    "Pallet jacks",
    "Scale",
    "Tarpaulin",
    "Moisture meter",
    "Conveyors",
    "Automated guided vehicles (AGVs)",
    "Sorting systems"
  ];

  const crops = [
    "Maize",
    "Soya Beans",
    "Onion",
    "Pepper",
    "Tomatoes"
  ];

  const Food = [
    { value: "Cereals" },
    { value: "Industrial crops" },
    { value: "Legumes" },
    { value: "Fruits" },
    { value: "Vegetables" },
    { value: "Starchy" },
    { value: "tuber" },
    { value: "root crops" }
  ];

  const handleChange = (event) => {
    const { target: { value } } = event;
    setPersonName(typeof value === 'string' ? value.split(',') : value);
  };

  const handleChangecrops = (event) => {
    const { target: { value } } = event;
    setmulticrops(typeof value === 'string' ? value.split(',') : value);
  };

  const clearForm = () => {
    setwarehousetype("none");
    setPersonName([]);
    setmulticrops([]);
    document.getElementById("warehousename").value = "";
    document.getElementById("address").value = "";
    document.getElementById("contact").value = "";
    document.getElementById("storagesize").value = "";
    document.getElementById("description").value = "";
    document.getElementById("gpslocation").value = "";
    personName.forEach((_, i) => {
      document.getElementById("quantity" + i).value = "";
    });
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnackbarOpen(false);
  };

  const addwarehouse = () => {
    setloading(true);
    const listequipments = personName.map((item, i) => [
      item,
      document.getElementById("quantity" + i).value
    ]);

    const doer = async () => {
      try {
        const res = await axios.post("https://server.agrotraciserp.com/api/warehouse/addwarehouse/", {
          warehousename: document.getElementById("warehousename").value,
          address: document.getElementById("address").value,
          contact: document.getElementById("contact").value,
          warehousetype,
          equipments: personName,
          crops: multicrops,
          equipmentsquantity: listequipments,
          storagesize: document.getElementById("storagesize").value,
          description: document.getElementById("description").value,
          gpslocation: document.getElementById("gpslocation").value,
        });
        if (res.status === 200) {
          setloading(false);
          dispatch(getwarehouse( { data: res.data } ));
          setSnackbarMessage('Warehouse added successfully!');
          setSnackbarSeverity('success');
          setSnackbarOpen(true);
          clearForm();
          handleClose();
        } else {
          setloading(false);
          setSnackbarMessage('Failed to add warehouse.');
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
        }
      } catch (err) {
        setloading(false);
        setSnackbarMessage('An error occurred while adding warehouse.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      }
    };

    doer();
  };

  return (
    <div>
      <Button variant="outlined" startIcon={<WarehouseIcon />} onClick={handleOpen}>
        Add Warehouse
      </Button>
      <Dialog fullWidth minWidth="sm" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Add new Warehouse
          <IconButton onClick={handleClose} style={{ float: "right" }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Box
            component="form"
            sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
            noValidate
            autoComplete="off"
          >
            <TextField
              id="warehousename"
              label="Warehouse Name"
              type="text"
              autoComplete="current-text"
            />
            <TextField
              id="address"
              label="Address"
              type="text"
              autoComplete="current-text"
            />
            <TextField
              id="gpslocation"
              label="Location (GPS)"
              type="text"
              autoComplete="current-text"
            />
            <TextField
              id="contact"
              label="Contact"
              type="tel"
              autoComplete="current-text"
            />
            <TextField
              id="outlined-select-currency-native"
              select
              label="Warehouse Type"
              value={warehousetype}
              onChange={(e) => setwarehousetype(e.target.value)}
              SelectProps={{
                native: true,
              }}
            >
              <option key="none" value="none">Choose</option>
              <option key="Primary" value="Primary">Primary</option>
              <option key="Secondary" value="Secondary">Secondary</option>
            </TextField>
            <TextField
              id="storagesize"
              label="Storage Area Size"
              type="text"
              autoComplete="current-text"
              InputProps={{
                endAdornment: <InputAdornment position="end">tons</InputAdornment>,
              }}
            />
            <FormControl sx={{ m: 1, width: 225 }}>
              <InputLabel id="demo-multiple-checkbox-label">Equipment</InputLabel>
              <Select
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                multiple
                value={personName}
                onChange={handleChange}
                input={<OutlinedInput label="Equipment" />}
                renderValue={(selected) => selected.join(', ')}
                MenuProps={MenuProps}
              >
                {names.map((name) => (
                  <MenuItem key={name} value={name}>
                    <Checkbox checked={personName.includes(name)} />
                    <ListItemText primary={name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <br />
            {personName.map((index, i) => (
              <div key={i}>
                <TextField
                  id={"equipment" + i}
                  label="Equipment"
                  value={index}
                  type="text"
                  disabled
                  autoComplete="current-text"
                />
                <TextField
                  id={"quantity" + i}
                  label="Quantity"
                  type="number"
                  autoComplete="current-text"
                />
              </div>
            ))}
            <FormControl sx={{ m: 1, width: 225 }}>
              <InputLabel id="demo-multiple-checkbox-label">Crops Kept</InputLabel>
              <Select
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                multiple
                value={multicrops}
                onChange={handleChangecrops}
                input={<OutlinedInput label="Crops Kept" />}
                renderValue={(selected) => selected.join(', ')}
                MenuProps={MenuProps}
              >
                {crops.map((name) => (
                  <MenuItem key={name} value={name}>
                    <Checkbox checked={multicrops.includes(name)} />
                    <ListItemText primary={name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              id="description"
              label="Warehouse Description"
              multiline
              rows={4}
            />
          </Box>
        </DialogContent>
        <Divider />
        <DialogActions>
          <div style={{ marginTop: 2, textAlign: "center", width: "100%" }}>
            {loading ? (
              <Button variant="outlined" startIcon={<Progress />} disabled>
                Loading...
              </Button>
            ) : (
              <Button variant="outlined" startIcon={<WarehouseIcon />} size="large" onClick={addwarehouse}>
                Submit New Warehouse
              </Button>
            )}
          </div>
        </DialogActions>
      </Dialog>
      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}